export const DATA_KEY_IS_GROUP = "mpse__grouping__model__const__is_group";
